import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import * as saveAs from 'file-saver';

import { IContractBeneficiario, IContractInput } from 'src/app/models/contract';
import { IBeneficiaryFormDialogData } from 'src/app/models/dialog';
import { ContratoBeneficiarioFormComponent } from 'src/app/pages/contratos/contrato-beneficiario-form/contrato-beneficiario-form.component';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { IChangeCommission } from '../../../models/generic';
import { SnackbarService } from '../../../services/snackbar.service';
import { beneficiarioInputInfos } from '../../utils/base';

@Component({
  selector: 'app-beneficiary-contract-card',
  templateUrl: './beneficiary-contract-card.component.html',
  styleUrls: ['./beneficiary-contract-card.component.scss']
})
export class BeneficiaryContractCardComponent implements OnInit, OnChanges {
  @Input() form!: FormGroup;
  @Input() index!: number;
  @Input() editableFields: string[] = [];
  @Input() cardType: string = 'Router';
  @Input() readonly = true;
  @Input() changedCommission!: IChangeCommission;

  @Output() removeItemFromArrayEvent = new EventEmitter<number>();

  beneficiaryContracts!: IContractBeneficiario;
  inputs: IContractInput[] = [];
  inputInfos = beneficiarioInputInfos;
  beneficiaryName!: string;
  hasChangedRate: boolean = false;

  removeItemBeneficiaryForm: { [key: string]: Function } = {
    Router: (indexBeneficiary: number) => {
      this._contractService.removeItemFromArray(indexBeneficiary);
    },
    Modal: (indexBeneficiary: number) => {
      this.removeItemFromArrayEvent.emit(indexBeneficiary);
    }
  };

  constructor(
    private _dialog: MatDialog,
    public _contractService: ApiContractService,
    private _snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this.hasChangedRate = this.form.value.BeneficiaryType.toLowerCase() === 'parceiro' &&
      !!this.changedCommission && !!this.changedCommission.JustificationChangeCommission;
    this.isModal();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildInputs();
  }

  isModal(): boolean {
    if (this.cardType === 'Modal') {
      return true;
    } else {
      return false;
    }
  }

  buildInputs(): void {
    this.inputs = Object.keys(this.inputInfos).map((el) => {
      const input = {
        label: this.inputInfos[el]?.label,
        placeholder: this.inputInfos[el]?.placeholder,
        mask: this.inputInfos[el]?.mask,
        currency: this.inputInfos[el]?.currency,
        type: this.inputInfos[el]?.type
      } as IContractInput;

      const keys = Object.keys(this.form.controls);

      if (keys.some((control) => control === el)) {
        input.controlName = el;
      }


      return input;
    });
  }

  handleNewBeneficiarioModal(): void {
    const dialogData: IBeneficiaryFormDialogData = {
      form: new FormGroup({ ...this.form.controls }),
      editableFields: this.editableFields
    };

    const rowValue = this.form.getRawValue();

    const dialogRef = this._dialog.open(ContratoBeneficiarioFormComponent, {
      disableClose: true,
      data: dialogData,
      ariaLabel: 'Editar beneficiário'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          this._contractService.updateFormArray(this.index, res);
        } else {
          this.form.patchValue(rowValue);
        }
      }
    });
  }

  removeItemFromArray(index: number) {
    this.removeItemFromArrayEvent.emit(index);
  }

  downloadAgreementDocument(id: string, fileName: string): void {
    this._contractService.getContractChangeCommissionFile(id)
      .subscribe({
        next: (response) => {

          if (response) {
            const blob = new Blob([response], { type: 'application/octet-stream' });
            saveAs(blob, fileName);
          } else {
            this._snackbarService.openSnackBar(
              'Houve um erro ao baixar o arquivo',
              'danger',
              5000
            );
          }
        },
        error: (error) => {
          this._snackbarService.openSnackBar(
            'Houve um erro ao baixar o arquivo',
            'danger',
            5000
          );
          console.log(error);
        }
      });
  }
}
